export abstract class BaseAppError extends Error {
  abstract readonly kind: string
  readonly service: string
  readonly cause?: unknown
  readonly level: ErrorLevel

  constructor(message: string, service: string, opts?: Opts) {
    super(message)
    this.name = this.constructor.name
    this.service = service
    this.cause = opts?.cause
    this.level = opts?.level ?? 'error'
  }
}

/**
 * This would be used to decide if an error should be thrown or not
 *
 * @default 'error'
 */
type ErrorLevel = 'error' | 'warn'

export type Opts = {
  /**
   * @default 'error'
   */
  level?: ErrorLevel

  /**
   * Usually the 'error' object from catch block
   */
  cause?: unknown
}
